/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ApiBody } from './apiBody';
import { ApiHeaders } from './apiHeaders';
import { ApiParams } from './apiParams';
import { BasePOCOMongoEntity } from './basePOCOMongoEntity';
import { EntityStatus } from './entityStatus';
import { VasServiceTypeEnum } from './vasServiceTypeEnum';


export interface Relay extends BasePOCOMongoEntity { 
    id: string | number;
    returnId?: string;
    contentName?: string;
    contentPartnerName?: string;
    serviceCode?: string;
    contentType: number;
    filterExpression?: string;
    relayConnectionType: number;
    networkOperatorCode?: string;
    serviceTypeName?: string;
    serviceType: VasServiceTypeEnum;
    contentRequestRoute?: string;
    apiBaseUrl?: string;
    apiMethodType?: string;
    grantType?: string;
    apiUserName?: string;
    apiKey?: string;
    apiPassword?: string;
    urlMethod?: string;
    headers?: Array<ApiHeaders>;
    params?: Array<ApiParams>;
    bodies?: Array<ApiBody>;
    smppSystemId?: string;
    systemType?: string;
    smppPassword?: string;
    smppIpAddress?: string;
    smppPort?: string;
    active: number;
    description?: string;
    serviceProviderId?: string;
    partnerId: number;
}
